export default __webpack_public_path__ + "fb89d692cc322e0cbc31d2d3877875d2.svg";